export default __webpack_public_path__ + "static/avatar-tag-anatomy-dark-0c33ed2c034b335427132be940606d30.png";